/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {signal} from '@preact/signals-react';
import {createMutator} from '../../store/SignalUtils';

/**
 * Defines the state for whether conflicts are checked.
 */
export const isConflictsChecked = signal<boolean>(false);
export const setIsConflictsChecked = createMutator<boolean>(isConflictsChecked);
